"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .expiration(15552000)
    .unit("U/L")
    .min(0.5)
    .max(20)
    .interpretation({ vocab: "htx", code: "inr" })
    .tag({ vocab: "snomed", code: "1951000175101" })
    .tag({ vocab: "loinc", code: "34714-6" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "htx", code: "lab_hepat" });
